<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pb_code,pb_vendname,pb_remark"
      placeholder="输入单据编号、供应商、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/money/payment/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pb_vendname}}</p>
          <p class="list-item-muted">{{item.pb_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.pb_pdamount}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pb_status!='已审核'}"
          >{{item.pb_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('pb_pdamount')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/money/paybalance/list",
      filters: [
        {
          type: "date",
          name: "pb_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "pb_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "pb_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>